<section
  class="flex gap-[8px] w-full"
  [ngClass]="{
    'flex-col': flexDirection() === 'column',
    'flex-row items-center flex-wrap': flexDirection() === 'row',
  }"
>
  @if (label() || (label() === '')) { @if (skeleton()) {
  <lib-skeleton-loader
    class="w-1/2"
    [theme]="{
      'height.px': 24,
      'width.%': 100
    }"
  ></lib-skeleton-loader>
  } @else {
  <div
    class="flex gap-[4px]"
    [ngClass]="{
        'opacity-50': disabled(),
      }"
  >
    <label [for]="for()" class="leading-[24px] flex items-start gap-[4px] label-semibold overflow-hidden">
      <span class="text-foreground leading-[24px]" lib-truncate-tooltip [disabled]="!truncateLabel()">{{
        label() | translate
      }}</span>
      @if (required()) {
      <span class="text-danger leading-[20px]">*</span>
      }
    </label>
    <!-- Sibling of the label, never inside it: a click on a <label> focuses its control. -->
    @if (infoTooltip() || infoTooltipRef()) {
    <i
      class="fi fi-rr-info cursor-help self-center leading-[0] text-[14px] text-muted-foreground"
      lib-tooltip
      [tooltipContent]="infoTooltip()"
      [disableTooltip]="!infoTooltip() || !!infoTooltipRef()"
      [libTooltipFollow]="infoTooltipRef()"
    ></i>
    }

    @if (contentRight()) {
    <span class="content-sm-regular text-muted-foreground ml-auto my-auto" lib-truncate-tooltip>
      {{ contentRight() }}
    </span>
    }
  </div>
  } }
  <ng-content></ng-content>
</section>
